import tracking from "@irati-tracking/recognition/recognition"
import navigationTracking from "@irati-tracking/recognition/navigation"
import {WalletRoutes} from "@irati-web/wallet/src/enums/Routes"
import authentication from "@irati/auth"
import {Card} from "@irati/ui/src/Layout"
import {PaymentCurrencyType, WalletEntityType} from "@irati/types"
import {TextButton} from "@irati/ui/src/Button"
import Flex from "@irati/ui/src/Flex"
import {useTheme} from "@irati/ui/src/global/useTheme"
import {H4, Body} from "@irati/ui/src/Typography"
import apps from "@irati-web/app/src/routeConfig"
import History, {appOrContext, historyContext} from "@irati/utils/history"
import FormattedMessage, {FormattedNumber} from "@irati/utils/lang"
import WalletBallance from "@irati/wallet/apollo/query/Wallet"
import React from "react"
import iconReward from "../../images/reward-card-icon.svg"
import {RecognitionRoutes} from "../../enums/Routes"
import {ActionContainer} from "./CardAction"

const RewardCardAction: React.FC = (_, context) => {
  const theme = useTheme()
  const canReward = authentication.apps("wallet.flexiRewards.canRewardEmployees")
  const isAdmin = authentication.isGlobalAdmin()
  if (!canReward) {
    return null
  }
  const hasRedirectToCreateRecognition = !isAdmin && canReward
  const onGiveRewardPointsClick = () => {
    if (hasRedirectToCreateRecognition) {
      tracking.startCreateRecognition("rp_widget_manager")
    }
    navigationTracking.giveRewardsPoints(context.app)
    const to = hasRedirectToCreateRecognition ? RecognitionRoutes.CREATE_RECOGNITION : WalletRoutes.FLEXI_ASSIGN
    const app = hasRedirectToCreateRecognition ? apps.RECOGNITION : apps.WALLET
    History.push(appOrContext({to, app}, context))
  }
  return (
    <ActionContainer>
      <TextButton onClick={onGiveRewardPointsClick}>
        <Card small>
          <Flex gap={theme.spacing.oneAndHalf} alignItems="center">
            <img src={iconReward} height={theme.spacing.five} />
            <Flex direction="column">
              <H4>
                <FormattedMessage id="recognition.celebrationHub.rewardCard.header" />
              </H4>
              <WalletBallance
                fetchPolicy="network-only"
                variables={{userId: authentication.user().uuid, currency: PaymentCurrencyType.Rp, entityType: WalletEntityType.Reward}}>
                {({data}) => (
                  <Body small>
                    <FormattedMessage
                      id="recognition.celebrationHub.rewardCard.subtitle"
                      values={{
                        points: <FormattedNumber value={data.wallet?.availableBalance} />
                      }}
                    />
                  </Body>
                )}
              </WalletBallance>
            </Flex>
          </Flex>
        </Card>
      </TextButton>
    </ActionContainer>
  )
}
RewardCardAction.contextTypes = historyContext

export default RewardCardAction
